import { httpGet, httpGetRoute } from "../utils/http.service"
import type { ChangelogsResponse } from "../json-schemas/serializers/changelogs-response"

export function changelogsGet (): Promise<ChangelogsResponse> {
  return httpGet(`/${httpGetRoute()}/changelogs`)
}